<template>
  <span class="agent-status-badge">
    <span class="agent-status-badge__pill" :class="`agent-status-badge__pill--${status}`">
      <svg v-if="status === 'healthy'" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 9.5l3 3 7-7"/></svg>
      <svg v-else-if="status === 'stale'" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="9" cy="9" r="6.5"/><path d="M9 5.5v3.8l2.6 1.6"/></svg>
      <svg v-else-if="status === 'unmanaged'" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4l10 10M14 4 4 14"/></svg>
      <svg v-else-if="status === 'enrolling'" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M9 2.5a6.5 6.5 0 1 1-6.5 6.5"/></svg>
      <svg v-else viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="9" cy="9" r="6.5"/><path d="M9 12v.01M9 6v3.5"/></svg>
      {{ meta.label }}
    </span>
    <span v-if="sub" class="agent-status-badge__sub">{{ sub }}</span>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { agentStatusMeta } from '@root/services/serverFormat';

// The agent-connectivity signal ONLY (`agent-status-badge.html`) —
// healthy/stale/unmanaged/enrolling. `dual_reporting` is retired per the
// direct-cutover ruling (Plan 003 §4d, Toby 2026-07-16) and deliberately has
// no rendering branch here beyond the generic fallback.
const props = defineProps({
  status: {
    type: String,
    required: true,
  },
  sub: {
    type: String,
    default: null,
  },
});

const meta = computed(() => agentStatusMeta(props.status));
</script>

<style lang="scss">
.agent-status-badge {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;

  &__pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 11.5px;
    font-weight: 700;
    padding: 5px 11px;
    border-radius: 13px;
    white-space: nowrap;

    svg {
      width: 11px;
      height: 11px;
      flex-shrink: 0;
    }

    &--healthy {
      background: #e1f3ea;
      color: #1c7a4d;
    }

    &--stale {
      background: #fbeeda;
      color: #9c6a10;
    }

    &--unmanaged {
      background: transparent;
      border: 1.5px dashed var(--theme-text-tertiary);
      color: var(--theme-text-secondary);
    }

    &--enrolling {
      background: #ddeaf4;
      color: #215d84;
    }
  }

  &__sub {
    font-size: 10px;
    color: var(--theme-text-tertiary);
    font-family: var(--theme-font-mono);
  }
}
</style>
